export type NoticeCategory = 'urgent' | 'service' | 'loisirs' | 'personnalise' | 'municipal'

export interface Notice {
  id: string
  category: NoticeCategory
  title: string
  description: string
  when: string
  ago: string
  context?: string
  unread: boolean
}

export const categoryLabels: Record<NoticeCategory, string> = {
  urgent: 'Urgent',
  service: 'Service',
  loisirs: 'Loisirs',
  personnalise: 'Personnalisé',
  municipal: 'Vie municipale',
}

export const notices: Notice[] = [
  {
    id: 'ebullition',
    category: 'urgent',
    title: 'Avis d’ébullition',
    description: 'Votre adresse est concernée. Faites bouillir l’eau une minute avant consommation.',
    when: 'Aujourd’hui · 14 h 30',
    ago: 'il y a 12 min',
    context: '366, chemin Lakeshore',
    unread: true,
  },
  {
    id: 'collecte',
    category: 'service',
    title: 'Collecte des encombrants reportée',
    description: 'La collecte du 1er octobre est reportée au 8 octobre.',
    when: 'Hier · 16 h 10',
    ago: 'hier',
    context: 'Sud de l’autoroute 20',
    unread: true,
  },
  {
    id: 'natation',
    category: 'personnalise',
    title: 'Rappel — Natation junior',
    description: 'Le cours d’Emma commence samedi à 10 h au Centre récréatif.',
    when: '18 septembre',
    ago: '18 sept.',
    context: 'Emma Lavoie',
    unread: false,
  },
  {
    id: 'req-2790',
    category: 'service',
    title: 'Votre demande a été mise à jour',
    description: 'Lampadaire défectueux — #REQ-2790 · Nouveau statut : En traitement',
    when: '25 septembre · 9 h 05',
    ago: '25 sept.',
    context: '412, chemin Lakeshore',
    unread: true,
  },
  {
    id: 'biblio',
    category: 'personnalise',
    title: 'Documents à rapporter',
    description: '2 documents empruntés arrivent à échéance le 10 octobre.',
    when: '3 octobre',
    ago: '3 oct.',
    context: 'Bibliothèque de Beaconsfield',
    unread: true,
  },
  {
    id: 'milo-rappel',
    category: 'personnalise',
    title: 'Rappel pour Milo',
    description: 'Vaccin prévu le 14 octobre 2026.',
    when: '17 septembre',
    ago: '17 sept.',
    context: 'Milo · carte animale',
    unread: false,
  },
  {
    id: 'inscriptions',
    category: 'loisirs',
    title: 'Nouvelle plateforme d’inscription',
    description: 'Les inscriptions aux activités se font maintenant depuis votre espace citoyen.',
    when: '22 septembre',
    ago: '22 sept.',
    unread: false,
  },
  {
    id: 'travaux',
    category: 'service',
    title: 'Travaux chemin Lakeshore',
    description: 'Circulation locale seulement jusqu’au 10 octobre.',
    when: '16 septembre',
    ago: '16 sept.',
    context: 'À 400 m de votre adresse',
    unread: false,
  },
  {
    id: 'conseil',
    category: 'municipal',
    title: 'Séance du conseil municipal',
    description: 'Prochaine séance ordinaire le 19 octobre à 20 h.',
    when: '11 septembre',
    ago: '11 sept.',
    unread: false,
  },
]

export const activeAlert = {
  title: 'Avis d’ébullition — votre adresse est touchée',
  address: '366, chemin Lakeshore',
  addressLabel: 'Adresse principale',
  since: 'Depuis aujourd’hui, 14 h 30',
  summary:
    'Un avis d’ébullition est actuellement en vigueur pour cette adresse enregistrée dans votre profil.',
  concerns: 'L’adresse 366, chemin Lakeshore est dans la zone touchée.',
  todo: 'Faites bouillir l’eau au moins une minute avant consommation, selon l’avis officiel de la Ville.',
  questions: ['Puis-je boire l’eau ?', 'Puis-je en donner à mon animal ?', 'Quand l’avis sera-t-il levé ?'],
}

export const resolvedAlert = {
  title: 'Avis d’ébullition levé — nord de l’autoroute 20',
  detail: 'L’eau est de nouveau propre à la consommation depuis le 21 septembre à 16 h.',
}

export const avisChips = ['Mes alertes importantes', 'Non lus', 'Cette semaine', 'Paramètres']

export const avisQuestions = [
  'Pourquoi ai-je reçu cet avis ?',
  'Quels avis sont essentiels ?',
  'Comment changer mon numéro de téléphone ?',
  'Quelles adresses sont associées à mes alertes ?',
]

export interface ChannelPref {
  id: string
  label: string
  destination: string
  enabled: boolean
}

export const channelPrefs: ChannelPref[] = [
  { id: 'push', label: 'Notifications mobiles', destination: 'Application bciti+', enabled: true },
  { id: 'courriel', label: 'Courriel', destination: 'marianne.caldwell@courriel.com', enabled: true },
  { id: 'sms', label: 'SMS', destination: '(514) •••-0184', enabled: false },
]

export interface TopicPref {
  id: string
  label: string
  description: string
  enabled: boolean
}

export const topicPrefs: TopicPref[] = [
  { id: 'collectes', label: 'Collectes', description: 'Rappels et changements de collecte', enabled: true },
  { id: 'loisirs', label: 'Culture et loisirs', description: 'Inscriptions, rappels et changements', enabled: true },
  { id: 'travaux', label: 'Travaux et circulation', description: 'Travaux, fermetures et déneigement', enabled: true },
  { id: 'municipal', label: 'Vie municipale', description: 'Actualités et informations de la Ville', enabled: false },
  {
    id: 'personnalise',
    label: 'Services personnalisés',
    description: 'Informations sur vos services',
    enabled: true,
  },
]

export const alertPlaces = [
  { id: 'principale', address: '366, chemin Lakeshore', label: 'Adresse principale' },
  { id: 'secondaire', address: '130, Taywood Drive', label: 'Deuxième propriété' },
]
